import styles from './charts.module.css';

export function ChartTooltip({ active, payload, label, currency }) {
	if (!active || !payload?.length) return null;

	return (
		<div className={styles.tooltip}>
			{label && <p className={styles.tooltipTitle}>{label}</p>}
			{payload.map(entry => (
				<p key={entry.name} className={styles.tooltipRow}>
					<span style={{ color: entry.color ?? entry.payload.color }}>
						{entry.name}:
					</span>{' '}
					{Number(entry.value).toLocaleString('en-US', {
						maximumFractionDigits: 2,
					})}{' '}
					{currency}
				</p>
			))}
		</div>
	);
}
